module.exports = __webpack_public_path__ + "img/2.c7abc45a.png";